module.exports = __webpack_public_path__ + "static/media/delete.18bd7b9e.svg";